export interface YearAndPeriod {
    year: number;
    period: PeriodName;
}

export enum PeriodName {
    January = "January",
    February = "February",
    March = "March",
    April = "April",
    May = "May",
    June = "June",
    July = "July",
    August = "August",
    September = "September",
    October = "October",
    November = "November",
    December = "December",
    Q1 = "Q1",
    Q2 = "Q2",
    H1 = "H1",
    Q3 = "Q3",
    NineMonths = "NineMonths",
    Q4 = "Q4",
    H2 = "H2",
    Year = "Year",
    Month = "Month",
    NotSet = "NotSet",
    Quarter = "Quarter",
    MonthToDate = "MonthToDate",
    MonthFirstTill10nth = "Month (1 - 10)",
    Month11nthTill20nth = "Month (11 - 20)",
    Month21stTillEnd = "Month (21 - end)",
    QuarterToDate = "QuarterToDate",
    YearToDate = "YearToDate",
}

export interface Apartment {
    dateAdded: Date;
    dateRemoved?: Date;
    groupId: number;
    id: number;
    name: string;
    ownerIds: number[];
    shortName: string;
}

export enum Platform {
    Airbnb = 1,
    Booking = 2,
    Out = 3,
}
